/*
**********************************************************************************************
this is added to the _BasicWithMetricsLayout.cshtml & _AccountLayout2.cshtml 
& _BareLayout.cshtml & _BareAsyncLayout.cshtml files 
**********************************************************************************************
*/
async function init() {
    if (document.getElementById("needsRecaptcha")) {
        const { default: recaptcha } = await import('../../thirdparty/recaptcha/recaptchascript.js');
        recaptcha.init();
    }

    if (document.getElementById("noibuOn")?.value == "true") {
        const { default: noibu } = await import('../../thirdparty/noibu/noibu.js');
        noibu.init();
    }

    if (document.getElementById("includeSiteImproveAnalytics")?.value == "true") {
        const { default: SiteImprove } = await import('../../thirdparty/siteimprove/siteimprove.js');
        SiteImprove.init();
    }
}

await init();